export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
export const FULL_DATE_FORMAT = 'dd.MM.yyyy hh:mm:ss';
export const PERIOD = {
  month: 1,
  quarter: 3,
  year: 12,
};
